export default __webpack_public_path__ + "static/simple-area-2e2131e44b45f6ab9c09b79ca1a758b2.png";